export const PaymentStatus = {
	SCHEDULED: {
		statusName: 'SCHEDULED',
		statusTranslation: 'Scheduled'
	},
	INITIATED: {
		statusName: 'INITIATED',
		statusTranslation: 'Initiated'
	},
	INITIATED_SEPA: {
		statusName: 'INITIATED_SEPA',
		statusTranslation: 'InitiatedSEPA'
	},
	SENT: {
		statusName: 'SENT',
		statusTranslation: 'Sent'
	},
	ACCEPTED: {
		statusName: 'ACCEPTED',
		statusTranslation: 'Accepted'
	},
	PROCESSING_PARTNER: {
		statusName: 'PROCESSING_PARTNER',
		statusTranslation: 'ProcessingPartner'
	},
	PROCESSING_INTERMEDIARY: {
		statusName: 'PROCESSING_INTERMEDIARY',
		statusTranslation: 'ProcessingIntermediary'
	},
	PROCESSING_BENEFICIARY: {
		statusName: 'PROCESSING_BENEFICIARY',
		statusTranslation: 'ProcessingBeneficiary'
	},
	PROCESSING_NO_TRACKING: {
		statusName: 'PROCESSING_NO_TRACKING',
		statusTranslation: 'ProcessingNoTracking'
	},
	PENDING: {
		statusName: 'PENDING',
		statusTranslation: 'Pending'
	},
	CANCELED: {
		statusName: 'CANCELED',
		statusTranslation: 'Canceled'
	},
	REFUSED: {
		statusName: 'REFUSED',
		statusTranslation: 'Refused'
	},
	REJECTED: {
		statusName: 'REJECTED',
		statusTranslation: 'Rejected'
	},
	BLOCKED: {
		statusName: 'BLOCKED',
		statusTranslation: 'Blocked'
	},
	COMPLETED: {
		statusName: 'COMPLETED',
		statusTranslation: 'Completed'
	},
	RETURNED: {
		statusName: 'RETURNED',
		statusTranslation: 'Returned'
	}
}

export const findStatusKeyByName = (name) => {
	return Object.keys(PaymentStatus).find((key) => PaymentStatus[key].statusName === name)
}

export const findLastStatusKey = (orderedStatusList) => {
	return orderedStatusList?.length > 0
		? findStatusKeyByName(orderedStatusList[0].paymentStatus)
		: 'SCHEDULED'
}

export const findFirstStatus = (orderedStatus) => {
	const statusList = [...orderedStatus]
	let firstStatus = statusList
		.reverse()
		.find((status) => status.paymentStatus !== 'SCHEDULED')
	if (!firstStatus && orderedStatus.length > 0) {
		firstStatus = orderedStatus[orderedStatus.length - 1]
	}
	return firstStatus
}
